export default __webpack_public_path__ + "static/media/Masking1.f8c16240.jpg";